/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationAccountModel {
    getFixupPrototypeFunction() { return OperationAccountModel.fixupPrototype; }

    static newInstance(model: Partial<OperationAccountModel>): OperationAccountModel {
        let obj = Object.assign(new OperationAccountModel(), model);
        OperationAccountModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationAccountModel>): OperationAccountModel {
        if (!model) return null;
        return OperationAccountModel.newInstance(<OperationAccountModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationAccountModel) {
        if (!obj) return;

        models.OperationAccountModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationAccountModel): boolean {
        Object.setPrototypeOf(obj, OperationAccountModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
    }

    /**
     * cloud account name
     */
    cloud_account_name: string;

    /**
     * total count details
     */
    count: number;

}
